<template>
    <div class="home">
        <img class="home-img" alt="" src="../assets/website.png" />
        <div class="get-demo font-18" type="primary" @click="$router.push('/demoHome')">Get a Demo</div>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'HomeView',
    components: {}
};
</script>

<style lang="scss" scoped>
.home-img {
    max-width: 100%;
    height: auto;
}

.get-demo {
    position: absolute;
    bottom: -15%;
    left: 12%;
    transform: translateX(-50%);
    z-index: 10;
    text-align: center;
    width: 140px;
    height: 50px;
    line-height: 50px;
    background-color: rgb(247, 213, 79);
    color: rgb(23, 4, 91);
    font-weight: bold;
    cursor: pointer;
}
</style>
